import {
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Modal,
  Popover,
  TextField,
  Typography,
  Paper,
  Chip as MuiChip,
  Stack,
  useMediaQuery,
  Tooltip,
  CircularProgress,
  LinearProgress,
  Avatar
} from "@mui/material";

import { useEffect, useState } from "react";

import LeakAddIcon from '@mui/icons-material/LeakAdd';
import LeakRemoveIcon from '@mui/icons-material/LeakRemove';
import CastConnectedIcon from '@mui/icons-material/CastConnected';
import CastIcon from '@mui/icons-material/Cast';
import ConnectedTvIcon from '@mui/icons-material/ConnectedTv';
import TvIcon from '@mui/icons-material/Tv';
import TvOffIcon from '@mui/icons-material/TvOff';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import VerticalSplitIcon from '@mui/icons-material/VerticalSplit';
import WifiFindIcon from '@mui/icons-material/WifiFind';
import ResetTvIcon from '@mui/icons-material/ResetTv';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/PowerOff';
import VolumeDownIcon from '@mui/icons-material/VolumeDown';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import InfoIcon from '@mui/icons-material/Info';
import MemoryIcon from '@mui/icons-material/Memory';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import NetworkWifiIcon from '@mui/icons-material/NetworkWifi';
import AppShortcutIcon from '@mui/icons-material/AppShortcut';
import GridViewIcon from '@mui/icons-material/GridView';
import Tv from '@mui/icons-material/Tv';
import StoreIcon from '@mui/icons-material/Store';
import PhonelinkIcon from '@mui/icons-material/Phonelink';

import { useTheme } from '@mui/material/styles';
import { useContext } from "react";
import { LoadingContext, SocketContext, UserContext } from "../../../context/handleContext";
import axios from "axios";
import { api } from "../../../utils/defaults";
import { toast } from "react-toastify";
import { CopyToClipboard } from "react-copy-to-clipboard";

export default function Chip({ data, expanded, network, ...props }) {
    const [loading, setLoading] = useContext(LoadingContext);
    const [user] = useContext(UserContext);
    const [state, setState] = useState(data);
    const [connectionAnchor, setConnectionAnchor] = useState(null);
    const [appAnchor, setAppAnchor] = useState(null);
    const [cecState, setCecState] = useState({ open: false });
    const [password, setPassword] = useState({ open: false });

    const socket = useContext(SocketContext);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        setState(data);
        socket.on(`price_manager_monitor_${data?.idtabelapreco}`, e => setState(prev => ({...prev, ...e})));

        return () => {
        socket.off(`price_manager_monitor_${data?.idtabelapreco}`);
        };
    }, [data]);

    const getStatusColor = (status) => {
        return status ? theme.palette.success.main : theme.palette.error.main;
    };

    const renderResourceMeter = (value, max, label, icon) => {
        const percentage = max ? Math.round((value / max) * 100) : 0;
        return (
        <Box sx={{ width: '100%', mb: 1 }}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
            {icon}
            <Typography variant="caption" sx={{ fontWeight: 'bold' }}>{label}</Typography>
            <Typography variant="caption" sx={{ ml: 'auto' }}>{percentage}%</Typography>
            </Stack>
            <LinearProgress 
            variant="determinate" 
            value={percentage} 
            sx={{
                height: 6,
                borderRadius: 3,
                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[300],
                '& .MuiLinearProgress-bar': {
                borderRadius: 3,
                backgroundColor: percentage > 80 ? theme.palette.error.main : 
                                percentage > 60 ? theme.palette.warning.main : theme.palette.success.main
                }
            }}
            />
        </Box>
        );
    };

    const power = ( mode ) => {
        setLoading(true)
        axios
        .post(`${api}/api/manage/smartdisplay/action/television/state/${state.idtabelapreco}`,{
            device_id: cecState.address,
            state: mode
        },{
            headers: {
                Authorization: user.token
            }
        })
        .then(({data}) => toast.success('Enviado'))
        .catch(err => toast.error(err?.response?.data))
        .finally(() => setLoading(false))
    }
  
    const active = () => {
        setLoading(true)
        axios
        .post(`${api}/api/manage/smartdisplay/action/television/active/${state.idtabelapreco}`,{},{
            headers: {
                Authorization: user.token
            }
        })
        .then(({data}) => toast.success('Enviado'))
        .catch(err => toast.error(err?.response?.data))
        .finally(() => setLoading(false))
    }
  
    const volume = (state) => {
        // setLoading(true)
        // axios
        // .post(`${api}/hdmicec/volume/${cecState.address}/${state}`,{},{
        //     headers: {
        //         Authorization: user.token
        //     }
        // })
        // .then(({data}) => toast.success('Enviado'))
        // .catch(err => toast.error(err?.response?.data))
        // .finally(() => setLoading(false))
    }
  
    const submitPassword = () => {
        setLoading(true)
        axios
        .post(`${api}/api/manage/smartdisplay/action/password/${state.idtabelapreco}`,{
            password: password.password || null
        },{
            headers: {
                Authorization: user.token
            }
        })
        .then(({data}) => toast.success('Enviado'))
        .catch(err => toast.error(err?.response?.data))
        .finally(() => setLoading(false))
    }

  // Função para gerar iniciais a partir do nome da loja
    const getLojaInitials = (loja) => {
        if (!loja) return 'SL';
        const words = loja.split(' ');
        if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
        return words[0].substring(0, 1).toUpperCase() + 
            words[words.length - 1].substring(0, 1).toUpperCase();
    };

    return (
        <Paper
        elevation={3}
        sx={{
            m: isMobile ? 0 : 1,
            p: expanded ? 2 : 1,
            borderRadius: 2,
            width: expanded ? (isMobile ? 'calc(100% - 40px)' : '320px') : (isMobile ? 'calc(100% - 25px)' : '200px'),
            transition: 'all 0.3s ease',
            borderLeft: `4px solid ${getStatusColor(state.device || state.application)}`,
            position: 'relative',
            display: 'flex',
            flexDirection:'column',
            justifyContent:'space-between'
        }}
        >
        {/* Header Section - Sempre visível */}
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            <Box sx={{ overflow: 'hidden', display:'flex', flexDirection: 'column' }}>
                <Typography variant="caption" color="text.secondary">
                {state.apelido}
                </Typography>
            <CopyToClipboard 
                text={state.ip_address || ''}
                onCopy={() => {
                if (!state.ip_address) return;
                toast.success('IP copiado');
                }}
            >
                <Tooltip title={state.ip_address ? "Copiar IP" : "IP não disponível"}>
                <Typography 
                    variant={expanded ? "subtitle2" : "caption"}
                    sx={{
                    fontWeight: expanded ? 'bold' : 'normal',
                    cursor: state.ip_address ? 'pointer' : 'default',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                    }}
                >
                    {state.ip_address || 'Sem IP'}
                </Typography>
                </Tooltip>
            </CopyToClipboard>
            
            {expanded && (
                <Typography variant="caption" color="text.secondary">
                ID: {state.idtabelapreco} | {state.tipo_display || 'Tipo não definido'}
                </Typography>
            )}
            </Box>
            
            <MuiChip 
                label={expanded ? (state.loja || 'Sem loja') : state.idtabelapreco} 
                size="small" 
                sx={{ 
                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[200],
                fontSize: '0.65rem',
                height: 20
                }} 
            />
        </Stack>
        
        {/* Status Indicators - Apenas quando expandido */}
        {expanded && (
            <>
            <Stack direction="row" spacing={1} sx={{ mt: 1, mb: 2 }}>
                <Tooltip title={state.device ? "Dispositivo online" : "Dispositivo offline"}>
                <MuiChip
                    icon={<PhonelinkIcon fontSize="small" />}
                    label="Dispositivo"
                    size="small"
                    sx={{
                    backgroundColor: getStatusColor(state.device),
                    color: theme.palette.getContrastText(getStatusColor(state.device)),
                    '& .MuiChip-icon': {
                        color: theme.palette.getContrastText(getStatusColor(state.device)),
                        fontSize: '14px'
                    }
                    }}
                />
                </Tooltip>
                
                <Tooltip title={state.application ? "Aplicação online" : "Aplicação offline"}>
                <MuiChip
                    icon={<GridViewIcon fontSize="small" />}
                    label="Aplicação"
                    size="small"
                    sx={{
                    backgroundColor: getStatusColor(state.application),
                    color: theme.palette.getContrastText(getStatusColor(state.application)),
                    '& .MuiChip-icon': {
                        color: theme.palette.getContrastText(getStatusColor(state.application)),
                        fontSize: '14px'
                    }
                    }}
                />
                </Tooltip>
                
                <Tooltip title={state.cec_list?.length ? "TV detectada" : "TV não detectada"}>
                <MuiChip
                    icon={<Tv fontSize="small" />}
                    label="TV"
                    size="small"
                    sx={{
                    backgroundColor: state.cec_list?.length ? theme.palette.success.main : theme.palette.error.main,
                    color: theme.palette.getContrastText(state.cec_list?.length ? theme.palette.success.main : theme.palette.error.main),
                    '& .MuiChip-icon': {
                        color: theme.palette.getContrastText(state.cec_list?.length ? theme.palette.success.main : theme.palette.error.main),
                        fontSize: '14px'
                    }
                    }}
                />
                </Tooltip>
            </Stack>
            
            {/* Location Info */}
            <Typography 
                variant="caption" 
                sx={{ 
                display: 'block',
                mt: 0.5,
                color: theme.palette.text.secondary,
                fontStyle: state.area_venda ? 'normal' : 'italic'
                }}
            >
                {state.area_venda || 'Área de venda não definida'}
            </Typography>
            </>
        )}
        
        {/* Expanded Content */}
        {expanded && (
            <Box sx={{ mt: 2 }}>
            {/* Resource Monitoring */}
            <Paper variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                Monitoramento de Recursos
                </Typography>
                
                {renderResourceMeter(
                state.cpu_usage ? parseInt(state.cpu_usage) : 0,
                100,
                'CPU',
                <MemoryIcon fontSize="small" />
                )}
                
                {renderResourceMeter(
                state.memory_usage || 0,
                state.memory || 1,
                'Memória',
                <MemoryIcon fontSize="small" />
                )}
                
                {renderResourceMeter(
                state.temp ? parseInt(state.temp) : 0,
                100,
                'Temperatura',
                <ThermostatIcon fontSize="small" />
                )}
            </Paper>
            
            {/* Quick Actions */}
            <Stack direction="row" spacing={1} justifyContent="space-between">
                <Tooltip title="Gerenciar conexão">
                <Button
                    variant="outlined"
                    size="small"
                    disabled={!state.device}
                    onClick={({ currentTarget }) => setConnectionAnchor(currentTarget)}
                    startIcon={<PhonelinkIcon fontSize="small" />}
                    sx={{ flex: 1 }}
                >
                    dev
                </Button>
                </Tooltip>
                
                <Tooltip title="Gerenciar aplicação">
                <Button
                    variant="outlined"
                    size="small"
                    disabled={!state.application && !state.device}
                    onClick={({ currentTarget }) => setAppAnchor(currentTarget)}
                    startIcon={<GridViewIcon fontSize="small" />}
                    sx={{ flex: 1 }}
                >
                    App
                </Button>
                </Tooltip>
                
                <Tooltip title="Controle de TV">
                <Button
                    variant="outlined"
                    size="small"
                    disabled={!(state.device && state.cec_list?.length)}
                    onClick={() => setCecState({ open: state.device && state.cec_list?.length })}
                    startIcon={<Tv fontSize="small" />}
                    sx={{ flex: 1 }}
                >
                    TV
                </Button>
                </Tooltip>
            </Stack>
            </Box>
        )}
        
        {/* Collapsed Actions */}
        {!expanded && (
            <>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 1 }}>
                <Box>
                    <Typography variant="caption" sx={{ 
                    display: 'block',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}>
                    {state.loja || 'Sem Loja'}
                </Typography>
                <Typography variant="caption" sx={{ 
                    display: 'block',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}>
                    {state.area_venda?.split(' ')[0] || 'Área'}
                </Typography>

                    <Typography 
                    variant="caption" 
                    color="text.secondary" 
                    sx={{ fontSize: '0.6rem' }}>
                        {state.tipo_display}
                    </Typography>
                </Box>
                
                <Stack direction="row" spacing={0.5}>
                <Tooltip title={state.device ? "Dispositivo conectado" : "Dispositivo desconectado"}>
                    <Box sx={{ 
                    width: 8, 
                    height: 8, 
                    borderRadius: '50%', 
                    bgcolor: getStatusColor(state.device),
                    mt: 0.5
                    }} />
                </Tooltip>
                
                <Tooltip title={state.application ? "Aplicação conectada" : "Aplicação desconectada"}>
                    <Box sx={{ 
                    width: 8, 
                    height: 8, 
                    borderRadius: '50%', 
                    bgcolor: getStatusColor(state.application),
                    mt: 0.5
                    }} />
                </Tooltip>
                </Stack>
            </Stack>
            
            <Stack direction="row" spacing={0.5} justifyContent="space-between" sx={{ mt: 1 }}>
                <Tooltip title="Gerenciar conexão">
                <IconButton
                    size="small"
                    disabled={!state.device}
                    onClick={({ currentTarget }) => setConnectionAnchor(currentTarget)}
                    sx={{ p: 0.5, color: getStatusColor(state.device) }}
                >
                    <PhonelinkIcon fontSize="small" />
                </IconButton>
                </Tooltip>
                
                <Tooltip title="Gerenciar aplicação">
                <IconButton
                    size="small"
                    disabled={!state.application}
                    onClick={({ currentTarget }) => setAppAnchor(currentTarget)}
                    sx={{ p: 0.5, color: getStatusColor(state.application) }}
                >
                    <GridViewIcon fontSize="small" />
                </IconButton>
                </Tooltip>
                
                <Tooltip title="Controle de TV">
                <IconButton
                    size="small"
                    disabled={!(state.device && state.cec_list?.length)}
                    onClick={() => setCecState({ open: state.device && state.cec_list?.length })}
                    sx={{ p: 0.5, color: getStatusColor(state.cec_list?.length) }}
                >
                    <Tv fontSize="small" />
                </IconButton>
                </Tooltip>
            </Stack>
            </>
        )}
        
            <Modal
            open={password.open}
            onClose={() => setPassword({ open: false })}
            sx={{
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                width:'100%',
                height:'100%'
            }}
            >
                <div
                style={{ 
                    width: 320, 
                    backgroundColor: theme.palette.mode === 'dark' ? '#171717' : '#fff',
                    borderRadius:'10px',
                    overflowY:'auto',
                    maxHeight: '90vh',
                    display:'flex',
                    flexDirection:'column',
                    padding:'20px'
                }}>
                    <Typography
                    sx={{
                        color:'text.secondary',
                        marginBottom:'10px',
                        textAlign:'center'
                    }}
                    >Proteger acesso com senha</Typography>

                    <TextField
                    type='password'
                    value={password.password}
                    onChange={({target}) => setPassword({...password, password: target.value})}
                    sx={{
                        marginBottom: '10px'
                    }}
                    size='small'
                    label='Senha'
                    helperText={'Vazio p/ deixar sem senha'}
                    />

                    <Button
                    variant='outlined'
                    color='success'
                    onClick={submitPassword}
                    >
                        Enviar
                    </Button>
                </div>
            </Modal>

            <Modal
            open={cecState.address}
            onClose={() => setCecState({...cecState, address: undefined })}
            sx={{
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                width:'100%',
                height:'100%'
            }}
            >
                <div
                style={{ 
                    // width: '100%', 
                    maxWidth: 360, 
                    backgroundColor: theme.palette.mode === 'dark' ? '#171717' : '#fff',
                    // height:'90vh',
                    borderRadius:'10px',
                    overflowY:'auto',
                    maxHeight: '90vh'
                }}>
                    <div
                    style={{
                        display:'flex',
                        justifyContent:'space-between'
                    }}
                    >
                        <IconButton onClick={() => power('off')} sx={{m: 3}}>
                            <PowerOffIcon />
                        </IconButton>

                        <IconButton onClick={() => power('on')} sx={{m: 3}}>
                            <PowerIcon />
                        </IconButton>
                    </div>
                    <div
                    style={{
                        display:'flex',
                        justifyContent:'space-between'
                    }}>
                        <IconButton disabled onClick={() => volume('down')} sx={{m: 3}}>
                            <VolumeDownIcon />
                        </IconButton>
                        <IconButton disabled onClick={() => volume('mute')} sx={{m: 3}}>
                            <VolumeOffIcon />
                        </IconButton>
                        <IconButton disabled onClick={() => volume('up')} sx={{m: 3}}>
                            <VolumeUpIcon />
                        </IconButton>
                    </div>
                </div>
            </Modal>

            <Modal
            open={cecState.open}
            onClose={() => setCecState({open: false })}
            sx={{
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                width:'100%',
                height:'100%'
            }}
            >
                <List 
                sx={{ 
                    width: '100%', 
                    maxWidth: 360, 
                    bgcolor: theme.palette.mode === 'dark' ? '#171717' : '#fff',
                    // height:'90vh',
                    borderRadius:'10px',
                    overflowY:'auto',
                    maxHeight: '90vh'
                }}>
                    <div
                    style={{
                        width:'100%',
                        display:'flex',
                        justifyContent:'right'
                    }}
                    >
                        <Button
                        startIcon={<ResetTvIcon />}
                        onClick={active}
                        >
                            Entrada Ativa
                        </Button>
                    </div>
                    {(Array.isArray(state.cec_list) ? state.cec_list : []).filter(({error}) => !error).map((e) => (
                        <ListItem
                        sx={{width:'100%', color:'text.primary'}}
                        secondaryAction={
                            <div 
                            style={{
                                display:'flex', 
                                alignItems:'center'
                            }}>
                                <IconButton 
                                onClick={() => setCecState({ ...cecState, address: e.address })}
                                color="primary">
                                    <ControlCameraIcon />
                                </IconButton>
                                {/* {e.encryption_key === 'on' &&
                                <IconButton>
                                    <LockIcon sx={{fontSize:'15px'}} />
                                </IconButton>}

                                ControlCameraIcon
                                <WifiIndicator 
                                style={{
                                    width:'30px',
                                    height:'20px'
                                }}
                                strength={DBMToSignalStrength(e.signal_level)} /> */}
                            </div>  
                        }>
                            <ListItemButton
                            key={e.device_id}
                            // selected={selectedIndex === 0}
                            // onClick={() => setState({ ...e, open: true })}
                            >
                                {/* <ListItemIcon>
                                <InboxIcon />
                                </ListItemIcon> */}
                                <ListItemText primary={`${e.device}, ${e.vendor} - ${e.power_status}`} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Modal>

            <Popover 
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            anchorEl={connectionAnchor}
            open={connectionAnchor!==null}
            onClose={() => setConnectionAnchor(null)}
            >
                <Box sx={{ width: '100%', maxWidth: 200, bgcolor: 'background.paper' }}>
                    {state.device ? 
                    <List>
                        
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => setPassword({ open: true })}>
                                <ListItemIcon>
                                    {state.password ? <LockIcon /> : <LockOpenIcon />}
                                </ListItemIcon>
                                <ListItemText primary={!state.password ? "Bloquear com senha" : 'Alterar senha'} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton onClick={network}>
                                <ListItemIcon>
                                    <WifiFindIcon />
                                </ListItemIcon>
                                <ListItemText primary="Rede" />
                            </ListItemButton>
                        </ListItem>
                        
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => props.vnc(state)}>
                                <ListItemIcon>
                                    <ConnectedTvIcon />
                                </ListItemIcon>
                                <ListItemText primary="Acesso remoto" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton onClick={() => {
                                setLoading(true)
                                axios
                                .post(`${api}/api/manage/smartdisplay/action/shutdown/${state.idtabelapreco}`,{
                                    from: socket.id
                                },{
                                    headers: {
                                        Authorization: user.token
                                    }
                                })
                                .then(() => toast.success('Comando enviado'))
                                .catch(({response}) => toast.error(response.data))
                                .finally(() => setLoading(false))
                            }}>
                            <ListItemIcon>
                                <PowerSettingsNewIcon />
                            </ListItemIcon>
                            <ListItemText primary="Desligar" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => {
                                setLoading(true)
                                axios
                                .post(`${api}/api/manage/smartdisplay/action/reboot/${state.idtabelapreco}`,{
                                    from: socket.id
                                },{
                                    headers: {
                                        Authorization: user.token
                                    }
                                })
                                .then(() => toast.success('Comando enviado'))
                                .catch(({response}) => toast.error(response.data))
                                .finally(() => setLoading(false))
                            }}>
                                <ListItemIcon>
                                    <RestartAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Reiniciar" />
                            </ListItemButton>
                        </ListItem>
                    </List> : 
                    // <List>
                    //     <ListItem disablePadding>
                    //         <ListItemButton onClick={() => {
                    //             setLoading(true)
                    //             axios
                    //             .post(`${api}/api/manage/smartdisplay/action/monitor/${state.idtabelapreco}`,{
                    //                 from: socket.id
                    //             },{
                    //                 headers: {
                    //                     Authorization: user.token
                    //                 }
                    //             })
                    //             .then(() => toast.success('Comando enviado'))
                    //             .catch(({response}) => toast.error(response.data))
                    //             .finally(() => setLoading(false))
                    //         }}>
                    //             <ListItemIcon>
                    //                 <RestartAltIcon />
                    //             </ListItemIcon>
                    //             <ListItemText primary="Tentar reconexão" />
                    //         </ListItemButton>
                    //     </ListItem>
                    // </List>
                    <></>
                }
                </Box>
            </Popover>

            <Popover 
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            anchorEl={appAnchor}
            open={appAnchor!==null}
            onClose={() => setAppAnchor(null)}
            >
                <Box sx={{ width: '100%', maxWidth: 200, bgcolor: 'background.paper' }}>
                    <List>
                        {state.application && 
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => {
                                setLoading(true)
                                axios
                                .post(`${api}/api/manage/smartdisplay/action/application/calculate/${state.idtabelapreco}`,{
                                    from: socket.id
                                },{
                                    headers: {
                                        Authorization: user.token
                                    }
                                })
                                .then(() => toast.success('Comando enviado'))
                                .catch(({response}) => toast.error(response.data))
                                .finally(() => setLoading(false))
                            }}>
                                <ListItemIcon>
                                    <VerticalSplitIcon />
                                </ListItemIcon>
                                <ListItemText primary="Calcular" />
                            </ListItemButton>
                        </ListItem>}
                        {state.application && 
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => {
                                setLoading(true)
                                axios
                                .post(`${api}/api/manage/smartdisplay/action/reload/${state.idtabelapreco}`,{
                                    from: socket.id
                                },{
                                    headers: {
                                        Authorization: user.token
                                    }
                                })
                                .then(() => toast.success('Comando enviado'))
                                .catch(({response}) => toast.error(response.data))
                                .finally(() => setLoading(false))
                            }}>
                                <ListItemIcon>
                                    <RestartAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Recarregar" />
                            </ListItemButton>
                        </ListItem>}
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => {
                                setLoading(true)
                                axios
                                .post(`${api}/api/manage/smartdisplay/action/application/state/${state.idtabelapreco}`,{
                                    from: socket.id,
                                    state: state.application ? 'off' : 'on'
                                },{
                                    headers: {
                                        Authorization: user.token
                                    }
                                })
                                .then(() => toast.success('Comando enviado'))
                                .catch(({response}) => toast.error(response.data))
                                .finally(() => setLoading(false))
                            }}>
                                <ListItemIcon>
                                    <PowerSettingsNewIcon />
                                </ListItemIcon>
                                <ListItemText primary={`Tentar ${state.application ? 'fechar' : 'abrir'}`} />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Popover>
        </Paper>
        );
}